import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { CheckProfile } from "../../store/slices/auth"; 
import Loader from "../../common/Loader";

// Function to fetch profile and check access
const fetchCheckProfile = async (dispatch, id) => {
  try {
    const data = await dispatch(CheckProfile({ profile_id: id })).unwrap();
    return Boolean(data?.user?.status);
  } catch (error) {
    console.log("Error checking profile:", error.message);
    return false;
  }
};

const ProtectedRoutesLogIn = () => {
  // authState: null (loading), "UNAUTHENTICATED", "PROFILE_INCOMPLETE", "AUTHORIZED"
  const [authState, setAuthState] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkAuthorization = async () => {
      const user = Cookies.get("user");
      const lastActivity = localStorage.getItem("lastActivityTime");
      const INACTIVITY_LIMIT = 30 * 60 * 1000;

      if (!user || (lastActivity && Date.now() - parseInt(lastActivity, 10) > INACTIVITY_LIMIT)) {
        if (lastActivity && Date.now() - parseInt(lastActivity, 10) > INACTIVITY_LIMIT) {
          Cookies.remove("user");
          localStorage.removeItem("user");
        }
        setAuthState("UNAUTHENTICATED");
        return;
      }

      try {
        const userData = JSON.parse(user);
        const profileId = userData?.profile_id;

        if (!profileId) {
          setAuthState("UNAUTHENTICATED");
          return;
        }

        const isProfileComplete = await fetchCheckProfile(dispatch, profileId);
        if (isProfileComplete) {
          setAuthState("AUTHORIZED");
        } else {
          setAuthState("PROFILE_INCOMPLETE");
        }
      } catch (error) {
        console.error("Error parsing user cookie:", error);
        setAuthState("UNAUTHENTICATED");
      }
    };

    checkAuthorization();
  }, [dispatch]);

  // Show a loader while checking authorization
  if (authState === null) {
    return <Loader />;
  }

  // Redirect unauthenticated users to /login
  if (authState === "UNAUTHENTICATED") {
    return <Navigate to="/login" replace />;
  }

  // Redirect users with incomplete profiles to /adduserdetails
  if (authState === "PROFILE_INCOMPLETE") {
    return <Navigate to="/adduserdetails" replace />;
  }

  // If authorized and profile complete, render route
  return <Outlet />;
};

export default ProtectedRoutesLogIn;

